//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from "../other/Button";
import MtArrowLink from "../other/MtArrowLink";

export default {
  components: {
    Button,
    MtArrowLink
  },
  props: {
    masterpieceId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      email: '',
      formError: null,
      disabled: false
    }
  },
  computed: {
  },
  methods: {
    keepPatronForYourself() {
      // this.$axios({
      //   method: 'post',
      //   url: `/api/v1/patronage/setGift`,
      //   data: `lang=${this.$i18n.locale || 'ru'}&confirm=true&id=${this.masterpieceId}`
      // })
      //   .then(({data}) => {
      //     if (data.error) {
      //       this.formError = data.error.message
      //       this.disabled = false
      //     } else {
      //       this.$store.commit('changeIdForReturnPatronForm')
      //       this.$router.push(`/profile/detail?masterpieceId=${this.masterpieceId}&gpbPatronPaymentStatus=success`)
      //     }
      //   })
      //   .catch(err => {
      //     this.formError = err.message
      //     this.disabled = false
      //   })
      this.$store.commit('forms/changeIdForReturnPatronForm')
      this.$router.push(`/profile/detail?masterpieceId=${this.masterpieceId}&gpbPatronPaymentStatus=success&ignoreApi=true`)
    },
    sentGiftParton(email) {
      this.$axios({
        method: 'post',
        url: `/api/v1/patronage/sendGift`,
        data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&masterpieceId=${this.masterpieceId}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
            this.disabled = false
          } else {
            this.$store.commit('forms/changeIdForReturnPatronForm')
            setTimeout(() => {
              this.$store.commit('getConfigForSystemModal', {
                title: this.$t('patronCancel.giftSentModalTitle'),
                message: this.$t('patronCancel.giftSentModalMessage'),
                buttonText: this.$t('patronCancel.giftSentModalButton'),
                buttonColor: 'light'
              })
            }, 500)
          }
        })
        .catch(err => {
          this.formError = err.message
          this.disabled = false
        })
    }
  }
}
